export default "__VITE_ASSET__Bxt35D$C__"